import * as React from "react";
import {
  Box as MuiBox,
  Typography as MuiTypography,
  CardActions as MuiCardActions
} from "@mui/material";

import styled from "@emotion/styled";
import ButtonDropDown from "./ButtonDropDown";
import Loader from "../loader/loader";

const CardActions = styled(MuiCardActions)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0;
`;

const Box = styled(MuiBox)`
  display: flex;
  padding: 16px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  border-radius: 12px;
  background: var(--light-background-paper, #fff);
  box-shadow: 0px 4px 12px 0px rgba(191, 191, 191, 0.14);
`;

const Typography = styled(MuiTypography)``;
const CartTitleTypography = styled(MuiTypography)`
  color: #000000;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: capitalize;
`;

const TypographyPrice = styled(MuiTypography)`
  color: var(--light-text-primary, #192f67);
  font-size: 48px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: capitalize;
`;

const TypographySubTtile = styled(MuiTypography)`
  color: var(--light-text-secondary, rgba(0, 0, 0, 0.6));
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
interface CardContainerProps {
  title: string;
  totalNumber: any;
  isVisibleDropDownButton: boolean;
  subTitle?: any;
  getTransactions?: (data: any, value: any) => void;
  loading: any;
}

const CardContainer: React.FC<CardContainerProps> = ({
  title = "",
  totalNumber = null,
  isVisibleDropDownButton = false,
  subTitle = "",
  getTransactions = () => {},
  loading
}) => {
  return (
    <Box sx={{ minHeight: "153px" }}>
      <CardActions>
        <CartTitleTypography>{title}</CartTitleTypography>
        {isVisibleDropDownButton && (
          <ButtonDropDown
            menusOption={["Today", "Week", "Month"]}
            getTransactions={getTransactions}
            title={title}
          >
            {"Today"}
          </ButtonDropDown>
        )}
      </CardActions>
      {loading ? <Loader /> : <TypographyPrice>{totalNumber}</TypographyPrice>}
      {subTitle && <TypographySubTtile>{subTitle}</TypographySubTtile>}
    </Box>
  );
};

export default CardContainer;
